module.exports = __webpack_public_path__ + "static/img/res_5.6b7b24d0.png";